export default "__VITE_ASSET__57712f9d__"